(() => {
  const panel = document.getElementById("n8n-chat-panel");
  const toggleBtn = document.getElementById("n8n-chat-toggle");

  if (!panel || !toggleBtn) return;

  if (!window.betaFlags?.chat) return;

  toggleBtn.style.display = 'flex';

  let chatInitialized = false;

  async function initChat() {
    if (chatInitialized) return;
    chatInitialized = true;

    const webhookUrl = window.n8nChatWebhookUrl;
    const initialMessage =
      window.n8nChatInitialMessage || "Hi! How can I help you today?";

    try {
      const { createChat } =
        await import("https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js");

      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();
      const cartToken = cart.token;
      const cartGid = `gid://shopify/Cart/${cartToken}`;

      const metadata = {
        ...window.n8nChatMetadata,
        cartToken,
        cartGid
      }

      createChat({
        webhookUrl,
        target: "#n8n-chat-panel",
        mode: "fullscreen",
        showWelcomeScreen: false,
        loadPreviousSession: false,
        initialMessages: [initialMessage],
        enableStreaming: true,
        allowFileUploads: true,
        allowedFilesMimeTypes: "image/*",
        metadata,
        i18n: {
          en: {
            title: "Hi there! 👋",
            subtitle: "Start chatting with your n8n merch agent.",
            footer: "sdd",
            getStarted: "New Conversation",
            inputPlaceholder: "Type your question..",
          },
        },
      });
    } catch (err) {
      console.error("[n8n chat] Failed to load chat widget:", err);
      chatInitialized = false;
    }
  }

  function openPanel() {
    panel.classList.add("chat-panel-open");
    document.body.classList.add("chat-open");
    toggleBtn.setAttribute("aria-expanded", "true");
    toggleBtn.setAttribute("aria-label", "Close chat assistant");
    initChat();
  }

  function closePanel() {
    panel.classList.remove("chat-panel-open");
    document.body.classList.remove("chat-open");
    toggleBtn.setAttribute("aria-expanded", "false");
    toggleBtn.setAttribute("aria-label", "Open chat assistant");
  }

  toggleBtn.addEventListener("click", () => {
    if (panel.classList.contains("chat-panel-open")) {
      closePanel();
    } else {
      openPanel();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("chat-panel-open")) {
      closePanel();
      toggleBtn.focus();
    }
  });

  // Open links from chat messages in the same tab instead of a new one
  panel.addEventListener("click", (e) => {
    const link = e.target.closest("a[href]");
    if (!link) return;
    const href = link.getAttribute("href");
    if (href && /^https?:\/\//.test(href)) {
      e.preventDefault();
      window.location.href = href;
    }
  });
})();
